import React, { useState } from "react";
import { Button, Form, Checkbox, Steps } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import "./Application8.css";
import "../components/StepsTracker.css";

const Application8: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = () => {
    console.log("Form submitted");
    // Navigate to confirmation page
    navigate("/confirmation");
  };

  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="application-step-container">
      <div className="application-title-card">
        <div className="title-card-content">
          <div className="city-name-title">City of New Orleans, Louisiana</div>
          <h1 className="program-title-main">E-Bike Incentive Application</h1>
        </div>
      </div>

      <div className="progress-tracker-container">
        <Steps
          current={7}
          className="progress-tracker-steps"
          items={[
            { title: "Review Eligibility" },
            { title: "Confirm Details" },
            { title: "Personal Information" },
            { title: "Upload Documents" },
            { title: "Income Verification" },
            { title: "Survey" },
            { title: "Future Communications" },
            { title: "Terms & Conditions" },
          ]}
        />
      </div>

      <div className="main-step-card">
        <div className="step-header-container">
          <div className="step-badge">
            <div className="step-label">STEP</div>
            <div className="step-number">8</div>
          </div>
          <div className="step-content-info">
            <h2 className="step-title">Agree to Terms & Conditions</h2>
          </div>
        </div>

        <div className="step-divider" />

        <div className="terms-section">
          <div className="terms-title">
            City of New Orleans, E-Bike Incentive Program Terms & Conditions
          </div>
          <div className="terms-content">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas
              vel aliquam tellus, ac tempor mauris. Sed at tincidunt orci. Sed
              ac nunc ante. Praesent ut elementum justo. Phasellus vitae lacus
              felis. Nunc tempus vitae nisl efficitur viverra. Sed consectetur,
              orci ac condimentum aliquam, augue ligula convallis felis, et
              pulvinar leo mauris pharetra orci. Morbi aliquam, sapien a
              sagittis auctor, urna magna congue ex, non viverra erat felis
              vitae ipsum. Curabitur porta sed felis non lobortis. Fusce
              pellentesque libero ac condimentum rhoncus. Curabitur et magna
              bibendum lacus vestibulum feugiat non vitae lacus. Nam egestas
              ipsum eu tellus vulputate hendrerit. Praesent lectus ex, tincidunt
              ac ex non, iaculis fermentum lorem. Donec eu malesuada purus.
              Donec vitae congue lorem, a luctus tortor.
            </p>

            <p>
              Suspendisse sodales ante massa, ut dapibus lacus ultricies id.
              Aliquam mattis odio vitae odio posuere lacinia. Nullam ultricies
              ultricies lorem, quis semper erat sodales nec. Curabitur orci
              ligula, malesuada quis elit non, egestas elementum ligula. Duis
              odio ex, feugiat in magna vitae, ultrices luctus augue. Sed
              sollicitudin mollis dolor, eu ornare magna dapibus eget.
              Suspendisse ac blandit odio. Proin non mollis est, at ultrices
              mauris. Duis vulputate, diam quis laoreet dignissim, leo purus
              finibus sem, at venenatis augue lectus vitae metus. Proin nec
              volutpat turpis, ultrices dictum purus. Quisque erat libero,
              elementum sit amet nulla non, vestibulum aliquet est. Sed et
              finibus eros, nec ullamcorper sem.
            </p>

            <p>
              Cras hendrerit eget est sed volutpat. Nunc eu auctor ex. Nunc
              blandit imperdiet lorem consequat efficitur. Donec rutrum vitae
              mauris in condimentum. Pellentesque finibus sem vel pharetra
              pulvinar. Nullam interdum ligula sed nisi consequat lacinia. In
              velit nisi, vehicula ut auctor imperdiet, luctus quis lacus.
              Praesent sodales congue metus sit amet vestibulum. Vestibulum
              varius aliquam lectus et gravida. Nulla sodales, turpis et
              bibendum auctor, nisi nisl convallis elit, ut rutrum felis erat et
              felis. Donec vehicula ante risus, vulputate volutpat massa
              condimentum ac.
            </p>

            <p>
              Sed sed ullamcorper mi. Nullam quis mi elementum, blandit justo
              non, commodo metus. Aliquam gravida egestas nisi non blandit. Sed
              elementum placerat turpis vel iaculis. Ut viverra sit amet metus
              nec convallis. Nulla a posuere tortor. Morbi porta elementum diam,
              non auctor velit rhoncus eu. Sed fermentum libero ac pulvinar
              suscipit. Aliquam erat volutpat. Donec eget consequat magna, sit
              amet consectetur eros. Donec molestie feugiat nisl, ac euismod est
              gravida at. Nullam viverra ante vitae mauris pharetra, sed
              fermentum lectus suscipit. Aenean semper efficitur elit. Maecenas
              tincidunt pharetra tortor, sit amet pretium tortor efficitur
              vitae.
            </p>
          </div>

          <div className="terms-divider" />

          <Form form={form} layout="vertical" className="terms-agreement-form">
            <Form.Item name="agreeTerms" className="checkbox-form-item">
              <div className="checkbox-container">
                <Checkbox
                  className="terms-checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                <div className="checkbox-label">
                  I have read the Terms and Conditions and understand the safety
                  risks involved in operating an e-bike
                </div>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>

      <div className="navigation-buttons">
        <Link to="/application7">
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            className="back-button"
          >
            Back
          </Button>
        </Link>
        <Button
          type="primary"
          className="submit-button"
          size="large"
          onClick={handleSubmit}
        >
          Submit Application
        </Button>
      </div>
    </div>
  );
};

export default Application8;
